import React, { Component, Fragment } from 'react';
import {
    LoadingComponent,
    PageListComponent,
    HeaderListComponent,
    FormActionComponent,
    FormWrapperItem, FormWrapperInputComponent,
} from "../../../common/component/Index";
import { PATHS, DETAIL_ACTIONS, FEATURE_FLAGS } from "../../../../../constants/Define";
import { isEqual, get, cloneDeep, find } from 'lodash';
import * as Func from '../../../../../helpers/functions';
import Category from '../../../../../models/Category';
import Wrapper from './../../../common/component/Wrapper';

import './CategoryDetail.less';
import Input from "../../../common/component/Input";
import { checkUndefine } from "../../../../../helpers/functions";
import TranslateButton from '../../../common/component/TranslateButton';

let permisionActions = [];
const defaultState = {
    action: DETAIL_ACTIONS.CREATE,
    isSubmit: false,
    isGetItem: false,
    validation: {},
};

export default class CategoryDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...defaultState,
            category: this.props.categoryState.detail.category,
            uploadFiles: [],
        };
    }

    componentDidMount() {
        this.initDetail()
    }

    initDetail() {
        const { match, categoryState } = this.props;
        if (Object.keys(match.params).length > 0 && match.params.id) {
            const id = match.params.id;
            this.setState({ action: DETAIL_ACTIONS.UPDATE });
            this.props.getCategoryDetail(id);
        }
    }

    componentWillUnmount() {
        this.props.setCategoryDetail(new Category())
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.categoryState.detail.category && !isEqual(nextProps.categoryState.detail.category, this.props.categoryState.detail.category)) {
            this.setState({ category: nextProps.categoryState.detail.category, action: nextProps.categoryState.detail.category.id ? 'UPDATE' : this.state.action });
        }
    }

    render() {
        const { t, uploadState, categoryState } = this.props;
        const { isFetching } = categoryState;
        const { action, isSubmit, isGetItem, validation, category } = this.state;
        return (
            <LoadingComponent spinning={isFetching || isSubmit}>
                <PageListComponent className="category-detail-page">
                    <HeaderListComponent
                        path={this.props.match.path}
                        groupPath={'categories'}
                        titleHeader={action === "CREATE"
                            ? Func.capitalizeFirstLetter((`${t('action.create')} ${t('item.category.title')}`).toLowerCase())
                            : Func.capitalizeFirstLetter((`${t('action.update')} ${t('item.category.title')}`.toLowerCase()))
                        }
                        componentRight={FEATURE_FLAGS.TRANSLATE_ENABLE &&
                            <TranslateButton
                                languages={category.translations}
                                current={category.languageCode}
                                validation={validation.languageCode}
                                onChange={this.onShowTranslate}
                                onClear={this.onExitTranslate}
                                defaultSelecting={action === DETAIL_ACTIONS.CREATE}
                                onSelectDefault={language => this.onChange('languageCode', language.code)}
                                onRemove={this.onRemoveTranslate} />
                        }
                    />
                    <FormActionComponent
                        onSubmit={this.onSubmit}
                        isSubmit={isSubmit}
                        action={action}
                        isGetItem={isGetItem}
                        onClickBack={this.onClickBack}
                        backButtonText={action === DETAIL_ACTIONS.TRANSLATE ? t(`action.cancel`) : t(`action.back`)}
                        titleButtonSubmit={action === DETAIL_ACTIONS.TRANSLATE ? t(`action.save`) : undefined}
                        onChangeActive={e => this.onChangeDetail(e.name, e.value)}
                        submitButtonRight={true}
                        statusActiveName={`isActive`}
                    >
                        <Wrapper className='col-md-12 basic-section'>
                            <FormWrapperItem>
                                <Wrapper className="col-md-3" />
                                <Wrapper className="col-md-6">
                                    <FormWrapperInputComponent
                                        isRequired={true}
                                        isValidation={true}
                                        dataValidation={category.name}
                                        validation={validation.name}
                                        labelTitle={t(`item.category.name`)}
                                    >
                                        <Input placeholder="" type={`text`}
                                            className={`form-control`}
                                            name={`name`} onChange={(e) => this.onChange('name', e.target.value)}
                                            value={checkUndefine(category.name)} />
                                    </FormWrapperInputComponent>
                                </Wrapper>
                                <Wrapper className="col-md-3" />
                            </FormWrapperItem>
                        </Wrapper>
                    </FormActionComponent>
                </PageListComponent>
            </LoadingComponent>
        );
    }

    onChange = (fieldName, value) => {
        const category = this.state.category;
        category[fieldName] = value.trimLeft();
        this.setState({ category });
    };

    onClickBack = () => {
        if (this.state.action === DETAIL_ACTIONS.TRANSLATE) {
            this.onExitTranslate();
        } else {
            this.props.history.push(PATHS.CATEGORY.LIST.path);
        }
    }

    onShowTranslate = (language) => {
        const { category } = this.state;
        category.setTranslate(language.code);
        category.setData();
        this.setState({ category, action: DETAIL_ACTIONS.TRANSLATE });
    }

    onExitTranslate = () => {
        const category = cloneDeep(this.state.category);
        const action = DETAIL_ACTIONS[category.id ? 'UPDATE' : 'CREATE'];
        category.setTranslate(undefined, true);
        category.setData();
        this.setState({ category, action });
    }

    onSaveTranslate = () => {
        const { category } = this.state;
        const translateFunction = category.translate.id ? this.props.updateCategoryTranslate : this.props.createCategoryTranslate;
        translateFunction(category, category.languageCode);
        this.onExitTranslate();
    }

    onRemoveTranslate = (language) => {
        const { category } = this.state;
        category.setTranslate(language.code);
        this.props.deleteCategoryTranslate(category, { id: category.id });
    }

    onSubmit = (e) => {
        e.preventDefault();
        const { category, action } = this.state;
        if (this.validate()) {
            if (this.state.action === DETAIL_ACTIONS.TRANSLATE) {
                this.onSaveTranslate()
            } else if (action === DETAIL_ACTIONS.CREATE) {
                this.props.createCategoryDetail(category)
            } else {
                this.props.updateCategoryDetail({ category, props: this.props })
            }
        }
    };

    validate() {
        const { t } = this.props;
        let validate = {
            required: {
                name: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.category.name`)),
            }
        };
        if (this.state.action === DETAIL_ACTIONS.CREATE) {
            validate.required.languageCode = Func.formatValidation(t('validation.statusCode.code.1'), t(`translate.defaultLanguage`));
        }
        let valueValidate = {

        };
        const result = Func.multipleValidate(this.state.category, validate, valueValidate);
        this.setState({ validation: result });
        return Object.keys(result).length < 1;
    }
}
